<template>
    <div class="rounded-lg border border-gray-200 px-6 py-3">
        <div class="mb-2" v-html="trans('tasks.steps.photo.prompt', { name: label })" />
        <camera-capture
            :disabled="disabled"
            :existing-url="existingPhotoUrl"
            :hint="hint"
            :value="value"
            @change="emit('change', $event)"
            @upload-started="emit('upload-started')"
            @upload-completed="emit('upload-completed')"
        />
    </div>
</template>
<script setup>
import CameraCapture from '@/Components/CameraCapture.vue';
import { trans } from '@/mixins/i18n';

defineProps({
    label: String,
    hint: { type: String, default: null },
    disabled: Boolean,
    value: { type: String, default: null },
    existingPhotoUrl: { type: String, default: null },
});

const emit = defineEmits(['change', 'upload-started', 'upload-completed']);
</script>
